































































































































import {Component, Mixins} from 'vue-property-decorator'
import {Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {OcorrenciaTrackingResponsavel} from '@/model/resource/OcorrenciaTrackingResponsavel'
import {OcorrenciaTrackingResponsavelCollection} from '@/model/collection/OcorrenciaTrackingResponsavelCollection'
import {ListOcorrenciaTrackingResponsavelSchema} from '@/schema/resource/OcorrenciaTrackingResponsavel/ListOcorrenciaTrackingResponsavelSchema'
import {CsvOcorrenciaTrackingResponsavelSchema} from '@/schema/resource/OcorrenciaTrackingResponsavel/CsvOcorrenciaTrackingResponsavelSchema'
import {Env} from '@/helpers/Env'
import {XlsxHelper} from '@/helpers/XlsxHelper'

@Component
export default class ListOcorrenciaTrackingResponsavelView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListOcorrenciaTrackingResponsavelSchema()
  collection = new OcorrenciaTrackingResponsavelCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: OcorrenciaTrackingResponsavel) {
    Helper.pushByName('editOcorrenciaTrackingResponsavel', item.$id)
  }

  async removeItem(item: OcorrenciaTrackingResponsavel) {
    await new DialogRemove(item).confirm(() =>
      item.removeOcorrenciaTrackingResponsavel()
    )
    await this.collection.listOcorrenciaTrackingResponsavel()
  }

  async downloadXlsx() {
    const {ascending, orderBy, page, limit, ...params} = this.collection.params
    const collection = new OcorrenciaTrackingResponsavelCollection()
      .clearFilters()
      .addFilter(params)
    await collection.listCsvOcorrenciaTrackingResponsavel()
    this.$xlsx.downloadFromSchema(
      collection.all(),
      new CsvOcorrenciaTrackingResponsavelSchema(),
      this.$t('schema.CsvOcorrenciaTrackingResp.title') as string
    )
  }

  async uploadXlsx() {
    const langErrors = Object.keys(
      this.$t('resource.OcorrenciaTrackingResponsavel.errors')
    )
    const trackingsToPersist = new OcorrenciaTrackingResponsavelCollection()
    let hasError = false
    let index = 2
    const file = await Helper.promptForSingleFile('.xlsx')
    const data = await XlsxHelper.xlsxToNormalizeData(
      file,
      Env.XLSX_BLUEPRINT.CadastrarTracking,
      true
    )
    if (data) {
      try {
        data.forEach(item => {
          const newObj = OcorrenciaTrackingResponsavel.buildFromXlsx(item)
          if (newObj) {
            trackingsToPersist.add(newObj)
          }
          index++
        })
      } catch (e) {
        Helper.abort(
          this.$t('app.errorCsvReadLineComplete', {
            linha: index,
            error: (langErrors.includes(e.toString())
              ? this.$t(
                  `resource.OcorrenciaTrackingResponsavel.errors.${e.toString()}`
                )
              : e) as string,
          }) as string
        )
        hasError = true
      }
      if (!hasError) {
        const resp = await trackingsToPersist.persistListOcorrenciaTrackingResponsavel()
        Helper.success(
          this.$t('app.csvInsertTotal', {total: resp.length}) as string
        )
        await this.query()
      }
    } else Helper.abort('app.errorCsvReadFile')
  }
}
